<mat-card class="example-card">
    <mat-card-header class="titreFrm ">
        <mat-card-title>RESERVATION &Eacute;QUIPEMENT</mat-card-title>
    </mat-card-header>
    <mat-card-content class="border">
        <mat-card>
            <mat-card-content>
                <div *ngIf="exist;else attente"></div>
                <ng-template #attente>
                    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
                    <br>
                </ng-template>                
                <ng-template #fenetterModaleReservationEquipememt>
                    <div *ngIf="exist2;else attente2"></div>
                    <ng-template #attente2>
                        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
                    </ng-template>  
                    <form #formReservationEquipememt = "ngForm">
                        <div class="displayFlex3">
                            <button (click)="closeFrmReservationEquipememt()" mat-raised-button  class="colorRed"><mat-icon>close</mat-icon>Fermer</button>
                            <button (click)="verifierDisponibiliterReservationEtEnregistrer(formReservationEquipememt)" [disabled]="disabledBtn" mat-raised-button  class="colorGreen"><mat-icon>save</mat-icon>Enregistrer</button>
                        </div>
                        <!-- <mat-radio-group  name="Machine_salle" [(ngModel)]="machineOrSalle">
                            <mat-radio-button value="1">Éqipement</mat-radio-button>
                            <mat-radio-button value="2">Salle / Ateliers</mat-radio-button>
                        </mat-radio-group> -->
                        <div class="displayFlex2" *ngIf="machineOrSalle == '1'">
                            <mat-radio-group  name="Machine_Type" [(ngModel)]="reservation.Machine_Type" (change)="listeMachine_TypeChange()">
                                <mat-radio-button *ngFor="let type of listeMachine_Type" [value]="type.value">{{type.text}}</mat-radio-button>
                            </mat-radio-group>
                        </div>
                        <div class="displayFlex">
                            <app-recherche 
                            #collaborateurComponent
                            [style]="{'width' : '180px'}"
                            [disabled]="disabled" 
                            [api]="generalService.api" 
                            [numColonneToShow]="1" 
                            [numColonneToReturn]="0" 
                            [required]="true"
                            recherche="avtAcollaborateur" 
                            [param]="'0'" 
                            name="name_2" 
                            placeholder="Collaborateur" 
                            (ChampEnter)="blurCollaborateur($event)">
                        </app-recherche>
                            <!-- <mat-form-field     appearance="outline"  class="width-200">
                                <mat-label>Collaborateurs</mat-label>
                                <mat-select placeholder="Collaborateurs" name="xx" [(ngModel)]="reservation.Perso_Matricule" required>
                                    <mat-option *ngFor="let Perso of listeCollaborateurs" [(value)]="Perso.Perso_Matricule">{{Perso.Perso_Nom + " " + Perso.Perso_Prenom}}</mat-option>
                                </mat-select>
                            </mat-form-field> -->
                            <div>
                                <mat-form-field     appearance="outline"  class="width-140">
                                    <mat-label>Date début</mat-label>
                                    <input matInput name="dateDebut"  (dateChange)="dateActionChange('DATEDEBUT')"
                                        #dateDebut="ngModel" [(ngModel)]="reservation.DateDebut" [matDatepicker]="picker1"
                                        placeholder="Date début" required>
                                    <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                                    <mat-datepicker #picker1></mat-datepicker>
                                </mat-form-field>
                            </div>
                            <div>
                                <mat-form-field     appearance="outline"  class="width-140">
                                    <mat-label>Date fin</mat-label>
                                    <input matInput name="DateFin" (dateChange)="dateActionChange('DATEFIN')" 
                                        #DateFin="ngModel" [(ngModel)]="reservation.DateFin" [matDatepicker]="picker2"
                                        placeholder="Date fin" required>
                                    <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                                    <mat-datepicker #picker2></mat-datepicker>
                                </mat-form-field>
                            </div>                   
                        
                            <div style="width : auto">
                                <div class="displayFlex">
                                    <div style="width : auto">
                                        <mat-checkbox name="Matin_Checked" [(ngModel)]="MatinChecked" (change)="onMatinChecked()">
                                            <h5>Matin</h5>
                                        </mat-checkbox><br>
                                        <mat-form-field     appearance="outline"  style="width: 80px">
                                            <mat-label>H.D&eacute;but</mat-label>
                                            <input [disabled]="disabled || !MatinChecked" matInput name="HeureDebutAm" #Heure_DebutAm="ngModel" 
                                              [matAutocomplete]="auto8" [(ngModel)]="reservation.HeureDebutAm"
                                              (blur)="reservationHeureAMBlur($event,'HeureDebutAm')" placeholder="H.D&eacute;but"  [required]="MatinChecked"
                                              (input)="reservationTimeChangeAm($event)">
                                            <mat-autocomplete #auto8="matAutocomplete">
                                              <mat-option *ngFor="let option of filterdTimeAm" [value]="option">
                                                {{option}}
                                              </mat-option>
                                            </mat-autocomplete>
                                          </mat-form-field>

                                        <mat-form-field     appearance="outline"  style="width: 80px">
                                            <mat-label>H.Fin</mat-label>
                                            <input [disabled]="disabled || !MatinChecked" matInput name="HeureFinAm" #Heure_FinAm="ngModel" 
                                              [matAutocomplete]="auto7" [(ngModel)]="reservation.HeureFinAm"
                                              (blur)="reservationHeureAMBlur($event,'HeureFinAm')" placeholder="H.Fin"  [required]="MatinChecked"
                                              (input)="reservationTimeChangeAm($event)">
                                            <mat-autocomplete #auto7="matAutocomplete">
                                              <mat-option *ngFor="let option of filterdTimeAm" [value]="option">
                                                {{option}}
                                              </mat-option>
                                            </mat-autocomplete>
                                          </mat-form-field>
                                    </div>
                            
                                    <div style="width : auto">
                                        <mat-checkbox name="ApMidi_Checked" [(ngModel)]="ApMidiChecked" (change)="onApMidiChecked()" >
                                            <h5>Apr&egrave;s midi</h5>
                                        </mat-checkbox>
                                        <br>
                                        <mat-form-field     appearance="outline"  style="width: 80px">
                                            <mat-label>H.D&eacute;but</mat-label>
                                            <input [disabled]="disabled || !ApMidiChecked" matInput name="HeureDebutPm" #Heure_DebutPm="ngModel" 
                                              [matAutocomplete]="auto6" [(ngModel)]="reservation.HeureDebutPm"
                                              (blur)="reservationHeurePMBlur($event,'HeureDebutPm')" placeholder="H.D&eacute;but"  [required]="ApMidiChecked"
                                              (input)="reservationTimeChangePm($event)">
                                            <mat-autocomplete #auto6="matAutocomplete">
                                              <mat-option *ngFor="let option of filterdTimePm" [value]="option">
                                                {{option}}
                                              </mat-option>
                                            </mat-autocomplete>
                                        </mat-form-field>
                                        <mat-form-field     appearance="outline"  style="width: 80px">
                                            <mat-label>H.Fin</mat-label>
                                            <input [disabled]="disabled || !ApMidiChecked" matInput name="HeureFinPm" #Heure_FinPm="ngModel" 
                                              [matAutocomplete]="auto6" [(ngModel)]="reservation.HeureFinPm"
                                              (blur)="reservationHeurePMBlur($event,'HeureFinPm')" placeholder="H.Fin"  [required]="ApMidiChecked"
                                              (input)="reservationTimeChangePm($event)">
                                            <mat-autocomplete #auto6="matAutocomplete">
                                              <mat-option *ngFor="let option of filterdTimePm" [value]="option">
                                                {{option}}
                                              </mat-option>
                                            </mat-autocomplete>
                                        </mat-form-field>
                            
                                    </div>
                                </div>
                            </div>
                            <div *ngIf="reservation.Machine_Type == 5"  class="width-320">
                                <h5 style="margin-bottom: 50px;">Nbr de personne</h5>
                                <mat-radio-group  name="nbrPlace" [(ngModel)]="reservation.nbrPlace">
                                    <mat-radio-button *ngFor="let type of nbrPlace" [value]="type.value">{{type.text}}</mat-radio-button>
                                </mat-radio-group>
                            </div>
                            <div *ngIf="reservation.Machine_Type == 2">
                                <mat-form-field     appearance="outline"  class="width-200">
                                <mat-label>Lieu utilisation équipement</mat-label>
                                <input  matInput name="lieuUtilisation" #lieuUtilisation="ngModel" [(ngModel)]="reservation.lieuUtilisation"  placeholder="Lieu utilisation équipement">
                                </mat-form-field>
                            </div>   
                            <app-recherche  [disabled]="disabled" [api]="generalService.api" [numColonneToShow]="1" (ChampEnter)="ChampEnterClient($event)" 
                                    recherche="TierType" name="TierType" [param]="'1'" placeholder="Client">
                            </app-recherche>
                            <!-- <mat-form-field     appearance="outline"  style="margin-right: 10px;">
                                <mat-label>{{placeholderMachine}}</mat-label>
                                <input disabled="true" matInput name="xxxx" #xx="ngModel" [(ngModel)]="machineName"
                                [placeholder]="placeholderMachine" >
                            </mat-form-field>
                            <div (click)="openListeMachine()" style="margin-bottom: 5px; cursor: pointer;">
                                <mat-icon style="color: rgb(47, 88, 223);">search</mat-icon>
                            </div> -->
                            <app-recherche 
                            #rechercheMachine 
                            [api]="generalService.api" 
                            [param]="paramAppRecherche.param" 
                            [param2]="paramAppRecherche.param2"
                            [recherche]="paramAppRecherche.recherche" 
                            [placeholder]="paramAppRecherche.placeholder" 
                            [numColonneToShow]="1" 
                            [required]="true"  
                            (ChampEnter)="ChampEnterEquipement($event)" >
                            </app-recherche>
                        </div>
                        <!-- Angular Editor Supprimer -->
                        <!-- <angular-editor [config]="editorConfig" placeholder="Commentaire" name="Commentaire" #htmlEditor [(ngModel)]="reservation.commentaire"></angular-editor> -->
                    </form>      
                </ng-template>
                <div class="displayFlex2">
                    <div class=" width-400">
                        <button (click)="previewDate()" mat-raised-button  class="colorBlue"><mat-icon>navigate_before</mat-icon>Précédent</button>
                        <button (click)="now()" mat-raised-button  class="colorBlue"><mat-icon>adjust</mat-icon>Aujourd'hui</button>
                        <button (click)="nextDate()" mat-raised-button  class="colorBlue"><mat-icon>navigate_next</mat-icon>Suivant</button>
                    </div>
                    <button (click)="opentFrmAddNewReservation()" mat-raised-button  class="colorGreen"><mat-icon>add</mat-icon>Créer Réservation</button>
                </div>
                
                <app-calendar #calendarReservationComponent
                    *ngIf="showCalendarReservation"
                    [showHeader]="false"
                    [events]="eventsCalandar"
                    [selectable]="true" 
                    [editable]="true" 
                    [paramHeure]="paramHeure" 
                    [intervale]=7 
                    [htmlTitre]="true"
                    [defaultDate]="dateDebutAffichageCalendar"
                    (actionCalendar)="actionCalendar($event)"                    
                    >
                </app-calendar>
            </mat-card-content>
        </mat-card>
        
       
    </mat-card-content>
</mat-card>